
<template>
    <div>
        <div class="listbox-right"> 
            <h2><span>{{mainTitle}}</span></h2> 
            <ul> 
                <li v-for="(item,index) in liData"><a :class="item.isActive ? 'active' : '' "><span :class="item.isActive ? 'active' : '' " @click="routerData(item)" :to="item.routerTo">{{item.name}}</span></a></li>
                <!-- <li><a ><router-link to="introduction">公司简介</router-link></a></li> 
                <li><a href="/about/25.html">大事记</a></li>  -->
            </ul> 
        </div> 
    </div>
</template>

<script>
    export default {
        name: "Register",
        props:{
            mainTitle: {
				type: String,
				default: ''
			},
            liData:{
                type:Array,
                default:[]
            }
        },
        data(){
            return{

            }
        },
        methods:{
            routerData(e){
                console.log(e)
                this.$emit('routerData',e)
            }
        }
    }
</script>

<style scoped>
ul, ol, li {
    list-style: none;
}
    .listbox-right {
        float: right;
        width: 200px;
    }
    .listbox-right ul li a:hover{
        color: #18D1BB;
    }
    .active {
        color: #18D1BB;
    }
    .listbox-right ul li a {
        float: left;
        font-size: 14px;
        /* color: #000; */
    }
    .listbox-right ul li {
        width: 100%;
        float: left;
        line-height: 32px;
        box-sizing: border-box;
        padding-left: 15px;
        background: url(../../static/images/don.gif) no-repeat 5px center;
    }
    .listbox-right ul {
        width: 100%;
        float: left;
        margin: 15px 0;
        height: 128px;
    }
    div, form, ul, ol, li, span, p, dl, dt, dd, img {
        margin: 0;
        padding: 0;
        border: 0;
    }
    h1, h2, h3, h4, h5, h6 {
        margin: 0;
        padding: 0;
        font-size: 12px;
        font-weight: normal;
    }
    .contentlist .listbox-right h2 span {
        line-height: 48px;
        font-size: 18px;
        color: #000;
        float: left;
        margin-left: 10px;
    }
    .contentlist .listbox-right h2 {
        width: 100%;
        height: 48px;
        background-color: #f8f8f8;
        padding: 0 10px;
        box-sizing: border-box;
    }
</style>